import React, { useEffect, useState } from 'react'
// Component
import { subStringAvatar } from '../../components/Common/CellText'
//Styled Component
import { OverviewWrapper, UserName } from './MyProfilePageStyled'
// Ant design
import {
  Avatar,
  Button,
  Col,
  Form,
  Input,
  message,
  Radio,
  Row,
  Tooltip,
  Upload,
  DatePicker,
} from 'antd'
import { CameraFilled, CheckOutlined } from '@ant-design/icons'

// Other
import { blue } from '../../color'
import { inject, observer } from 'mobx-react'
import validator from '../../validator'
import moment from 'moment'

const nullText = 'Chưa cập nhật'

const Overview = props => {
  const {
    authenticationStore,
    loadingAnimationStore,
    userStore,
    aclStore,
  } = props

  const { aclAclGroupName } = aclStore

  const { currentUser, currentUserAvatar } = authenticationStore

  const [fields, setFields] = useState([
    {
      name: ['email'],
      value: undefined,
    },
    {
      name: ['phone'],
      value: undefined,
    },
    {
      name: ['home_phone'],
      value: undefined,
    },
    {
      name: ['gender'],
      value: undefined,
    },
  ])

  const setFieldsOrigin = () => {
    setFields([
      {
        name: ['email'],
        value: currentUser?.email,
      },
      {
        name: ['phone'],
        value: currentUser?.phone,
      },
      {
        name: ['home_phone'],
        value: currentUser?.home_phone,
      },
      {
        name: ['gender'],
        value: currentUser?.gender,
      },
    ])
  }

  const handleUploadAvatar = async (file, fileList) => {
    if (file.size / 1000 / 1024 > 3) {
      message.error('Vui lòng chọn file < 3MB')
    } else {
      const formData = new FormData()
      formData.append('file', fileList[0])
      loadingAnimationStore.showSpinner(true)
      try {
        await authenticationStore.updateCurrentUserAvatar(formData)
        await authenticationStore.getCurrentUserAvatar()
        message.success('Cập nhật avatar thành công')
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    }
    return false // Disable default Antd Design upload action
  }

  const onUpdate = async value => {
    const payload = {
      ...value,
      company_code: currentUser?.company?.code,
    }
    loadingAnimationStore.showSpinner(true)
    try {
      await userStore.updateCurrentUser(payload)
      authenticationStore.checkCurrentUser()
      message.success('Cập nhật thông tin thành công!')
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  useEffect(() => {
    if (!currentUser) return
    setFieldsOrigin()
  }, [currentUser])

  return (
    <OverviewWrapper>
      <div className={'avatar'}>
        <Avatar
          size={90}
          style={{ backgroundColor: blue }}
          src={currentUserAvatar && URL.createObjectURL(currentUserAvatar)}>
          {subStringAvatar(currentUser?.name_uppercase)}
        </Avatar>
        <Tooltip title={'Thay đổi ảnh đại diện'}>
          <Upload
            showUploadList={false}
            supportServerRender={true}
            beforeUpload={handleUploadAvatar}>
            <span className={'edit-avatar-icon'}>
              <CameraFilled />
            </span>
          </Upload>
        </Tooltip>
      </div>

      <div className={'overview-info'}>
        <Form onFinish={onUpdate} fields={fields} layout={'vertical'}>
          <UserName>
            <h2 style={{ marginBottom: 0, textTransform: 'capitalize' }}>
              {currentUser?.name_lowercase || nullText}
              <span className={'username'}>({currentUser?.username})</span>
            </h2>
          </UserName>

          <Row gutter={[20, 20]}>
            <Col xxl={12} xl={12} lg={24} md={24} sm={24} xs={24}>
              <Form.Item
                label={'Email'}
                name="email"
                rules={[
                  { required: true, message: 'Vui lòng nhập email!' },
                  { validator: validator.validateEmail },
                ]}>
                <Input placeholder={'Email'} />
              </Form.Item>

              <Form.Item label={'Mã nhân viên'}>
                <Input
                  placeholder={'Mã nhân viên'}
                  value={currentUser?.ma_nv || nullText}
                  disabled
                />
              </Form.Item>

              <Form.Item name={'home_phone'} label={'Số máy nội bộ'}>
                <Input placeholder={'Số máy nội bộ'} />
              </Form.Item>

              <Form.Item
                rules={[{ validator: validator.validatePhoneNumber }]}
                name={'phone'}
                label={'Điện thoại di động'}>
                <Input placeholder={'Điện thoại di động'} />
              </Form.Item>

              <Form.Item label={'Phân quyền'}>
                <Input
                  placeholder={'Phân quyền'}
                  value={aclAclGroupName}
                  disabled
                />
              </Form.Item>
            </Col>

            <Col xxl={12} xl={12} lg={24} md={24} sm={24} xs={24}>
              <Form.Item name={'gender'} label={'Giới tính'}>
                <Radio.Group>
                  <Radio.Button value={1}>Nam</Radio.Button>
                  <Radio.Button value={0}>Nữ</Radio.Button>
                  <Radio.Button value={2}>Khác</Radio.Button>
                </Radio.Group>
              </Form.Item>

              <Form.Item label={'Phòng ban'}>
                <Input
                  placeholder={'Phòng ban'}
                  value={currentUser?.department?.name || nullText}
                  disabled
                />
              </Form.Item>

              <Form.Item label={'Chức danh'}>
                <Input
                  placeholder={'Chức danh'}
                  value={currentUser?.position?.name || nullText}
                  disabled
                />
              </Form.Item>

              <Form.Item label={'Ngày sinh'}>
                <DatePicker
                  style={{ width: '100%' }}
                  placeholder={'Chức danh'}
                  format={'DD/MM/YYYY'}
                  value={
                    !currentUser?.birthDate
                      ? moment(currentUser?.birthDate)
                      : null
                  }
                  disabled
                />
              </Form.Item>
            </Col>

            <Col>
              <Button
                className={'custom-ant-button'}
                type={'primary'}
                icon={<CheckOutlined />}
                htmlType={'submit'}>
                Lưu thay đổi
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </OverviewWrapper>
  )
}

Overview.propTypes = {}

export default inject(
  'authenticationStore',
  'commonStore',
  'loadingAnimationStore',
  'userStore',
  'aclStore'
)(observer(Overview))
